/**
 * Financial-year helpers. FY runs Apr 1 → Mar 31.
 * FY 2026 == 'FY 2026-27' == 2026-04-01 → 2027-03-31.
 *
 * The FY list is loaded once from the backend on first use and cached in
 * localStorage so it survives a page reload without an extra round-trip.
 *
 * Security note: this cache contains only public configuration data (a list
 * of available FY year numbers). It holds no auth tokens or PII, so
 * localStorage is appropriate here.
 */
import api from "@/lib/api";

const CACHE_KEY = "bc_fy_cache_v1";

export function fyLabel(fy) {
  if (fy === null || fy === undefined) return "All time";
  return `FY ${fy}-${String(fy + 1).slice(-2)}`;
}

/** Compute current FY on the client (fallback if backend unreachable). */
export function computeClientFY() {
  const d = new Date();
  return d.getMonth() >= 3 ? d.getFullYear() : d.getFullYear() - 1;
}

let inflight = null;
export async function loadFinancialYears() {
  const cached = localStorage.getItem(CACHE_KEY);
  if (cached) {
    try {
      const parsed = JSON.parse(cached);
      if (parsed?.years?.length) return parsed;
    } catch (e) {
      // Corrupt cache — drop it and fall through to a fresh fetch.
      console.debug("FY cache invalid, refetching:", e?.message);
      localStorage.removeItem(CACHE_KEY);
    }
  }
  if (!inflight) {
    inflight = api
      .get("/config/financial-years")
      .then((r) => {
        localStorage.setItem(CACHE_KEY, JSON.stringify(r.data));
        return r.data;
      })
      .catch(() => ({ years: [], current_fy: computeClientFY() }));
  }
  return inflight;
}
